import SoundFile from './SoundFile'
import Reverb from './Reverb'

import unmute from './unmute.js'

export default class PlaybackEngine {
  constructor (items, callbacks) {
    //Engine status
    this.status = "initializing";
    this.individualSound = null;

    //Callbacks
    this.onLoading = callbacks.onLoading;
    this.onReady = callbacks.onReady;
    this.onPlaying = callbacks.onPlaying;
    this.onPaused = callbacks.onPaused;
    this.onStopped = callbacks.onStopped;
    this.onProgress = callbacks.onProgress;
    this.onFinished = callbacks.onFinished;

    //Internal methods that need binding
    this.soundLoaded = this.soundLoaded.bind(this);
    this.soundUnloaded = this.soundUnloaded.bind(this);
    this.play = this.play.bind(this);
    this.stop = this.stop.bind(this);
    this.stopIndividual = this.stopIndividual.bind(this);
    this.setVolume = this.setVolume.bind(this);

    //WebAudio stuff
    this.audioContext = new (window.AudioContext || window.webkitAudioContext)();

    unmute(this.audioContext);

    this.reverb = new Reverb(this.audioContext, {
      mix: 0.35,
      time: 0.5,
      decay: 0.5,
      reverse: 0
    });

    this.itemsGain = this.audioContext.createGain();
    this.itemsGain.gain.value = 0.7;

    this.globalGain = this.audioContext.createGain();
    this.globalGain.gain.value = 1.0;

    this.musicGain = this.audioContext.createGain();
    this.musicGain.gain.value = 1.0;

    this.assetsGain = this.audioContext.createGain();
    this.assetsGain.gain.value = 0.7;


    this.reverb.connect(this.itemsGain);

    this.itemsGain.connect(this.globalGain);
    this.musicGain.connect(this.globalGain);
    this.assetsGain.connect(this.globalGain);
    this.globalGain.connect(this.audioContext.destination);

    //Used to stop the context playback when we are done.
    this.playingTimeout = null;
    this.progressInterval = null;

    //Used to keep count of sound scheduling
    this.previousTime = -1;
    this.totalDuration = -1;

    this.pausedTime = -1;

    //All commmon sounds to be used
    this.intro = new SoundFile("assets/Intro.mp3",
                                  this.audioContext,
                                  this.soundLoaded,
                                  this.soundUnloaded,
                                  {asset : "intro"})

    this.outro = new SoundFile("assets/Outro.mp3",
                                  this.audioContext,
                                  this.soundLoaded,
                                  this.soundUnloaded,
                                  {asset : "outro"})

    this.loopMusique = new SoundFile("assets/Loop_musique.mp3",
                                  this.audioContext,
                                  this.soundLoaded,
                                  this.soundUnloaded,
                                  {asset : "loopMusique"})

    //For convinience load assets in an array
    this.assets = [this.intro, this.outro, this.loopMusique];

    //Items to eventually be played
    this.soundFiles = [];
    items.forEach((item, i) => {
      let soundFile = new SoundFile(  item.soundFile,
                                      this.audioContext,
                                      this.soundLoaded,
                                      this.soundUnloaded,
                                      { index: i, item })

      this.soundFiles.push(soundFile);
    });

    //Items choosen to be played
    this.list = [];

    //Buffers list changes when previewing an item;
    this.cuedList = null;

    //Down this all this setup, load the assets
    this.assets.forEach((asset, i) => {
      //We will be creating additionnal buffers when we know the proper length
      asset.load();
      asset.reload(1);
    });
  }


  setList(items){
    if(this.status == "waitingIndividual" || this.status == "playingIndividual"){
      this.cuedList = items;
      return;
    }

    //Stop playback when chaging stuff
    this.stop();

    //Need to ensure the same item is not present twice in our playback
    function uniq(a) {
      var prims = {"boolean":{}, "number":{}, "string":{}}, objs = [];

      return a.filter(function(item) {
          var type = typeof item;
          if(type in prims)
              return prims[type].hasOwnProperty(item) ? false : (prims[type][item] = true);
          else
              return objs.indexOf(item) >= 0 ? false : objs.push(item);
      });
    }

    items = uniq(items);

    //Clear previously cued list as we are treating it here
    this.cuedList = null;

    this.list = [];
    items.forEach((item, i) => {
      let soundFile = this.soundFiles.find(soundFile => soundFile.context.index == item);
      soundFile.load();
      this.list.push(soundFile);
    });

    //We'll need a bunch of these
    this.loopMusique.reload(1);


  }

  cueSound(soundFile, destination, bufferIndex=0, noUpdate=false, timeOverride=-1){
    let realDuration = soundFile.getBuffer(bufferIndex).buffer.duration;

    soundFile.getBuffer(bufferIndex).connect(destination);

    if(timeOverride >= 0){
      soundFile.getBuffer(bufferIndex).start(this.previousTime + timeOverride);
    }else{
      soundFile.getBuffer(bufferIndex).start(this.previousTime + this.totalDuration);
    }


    if(!noUpdate){
      this.totalDuration = this.totalDuration + realDuration;
    }

  }

  play(preview=false) {

    if(this.status == "paused"){
      this.resume();
    }

    if(this.status != "ready"){
    //  throw "Trying to play when not ready";
      return;
    }

    //We need to start scheduling at the time where our context is at
    this.audioContext.suspend();
    this.previousTime = this.audioContext.currentTime;
    this.totalDuration = 0;

    //this.cueSound(this.intro, this.audioContext.destination);
    //this.cueSound(this.introCoeur, this.audioContext.destination);

    //let refrainCount = Math.ceil((this.list.length - 8) / 8)

    let measureLength = 1.0;
    if(!preview){
      this.cueSound(this.intro, this.assetsGain);
    }

    this.list.forEach((soundFile, i) => {
      this.cueSound(soundFile, this.reverb.inputNode);
      //Leave one measure of music after each item
      //if(!preview){
        this.totalDuration = this.totalDuration + measureLength
      //}

    });

    if(!preview){
      this.cueSound(this.outro, this.assetsGain);
    }

    if(!preview){
      //We need to figure out the total duration to cue the music
      let musicDuration = this.loopMusique.getBuffer(0).buffer.duration;

      //let musicStart = this.intro.getBuffer(0).buffer.duration;
      let musicStart = this.intro.getBuffer(0).buffer.duration - Math.round(this.intro.getBuffer(0).buffer.duration);
      let musicTotalDuration = this.totalDuration - musicStart - this.outro.getBuffer(0).buffer.duration;


      let totalMusicBuffers = Math.ceil(musicTotalDuration / musicDuration);
      this.loopMusique.reload(totalMusicBuffers);

      for(let i = 0; i < totalMusicBuffers; i=i+1){
        this.cueSound(this.loopMusique, this.musicGain, i, true, musicStart + i * musicDuration);
      }
    }

    this.status = "playing"

    this.playingTimeout = setTimeout(() => {

      if(typeof this.onFinished == 'function'){
        this.onFinished();
      }

      this.stop();
    }, this.totalDuration * 1000);

    this.progressInterval = setInterval(() => {
      let progress = (this.audioContext.currentTime - this.previousTime) / this.totalDuration;

      if(typeof this.onProgress == 'function'){
        this.onProgress(progress);
      }

    }, 50);

    this.audioContext.resume();
  }

  stop() {
    if(this.status != "playing" && this.status != "paused"){
      //throw "Trying to stop when not playing";

      return;
    }

    //Stop all items that could be playing
    this.list.forEach((item, i) => {

      item.buffers.forEach((buffer, j) => {
        buffer.stop();
      });

      //Recreate the AudioBufferSource so that we are ready to start again.
      item.reload();
    });

    //Stop all scheduled assets
    this.assets.forEach((item, i) => {

      item.buffers.forEach((buffer, j) => {
        //Temporary try catch because not everything is scheduled here
        try{
          buffer.stop();
        }catch(error){

        }
      });

      //Recreate the AudioBufferSource so that we are ready to start again.
      item.reload();
    });

    if(typeof this.onStopped == 'function'){
      this.onStopped();
    }

    clearTimeout(this.playingTimeout);
    clearInterval(this.progressInterval);

    this.individualSound = null

    this.status = "ready"
  }

  playFile(id){
    this.stop();

    if(this.status == "waitingIndividual" || this.status == "playingIndividual"){
      this.stopIndividual();
    }

    this.status = "waitingIndividual"

    this.individualSound = this.soundFiles.find(soundFile => soundFile.context.item.id == id);
    this.individualSound.reload();
  }

  playIndividual(){
    if(this.status != "waitingIndividual"){
        return;
    }

    this.audioContext.suspend();
    this.previousTime = this.audioContext.currentTime;
    this.totalDuration = 0;

    this.cueSound(this.individualSound, this.globalGain);

    this.status = "playingIndividual"

    this.playingTimeout = setTimeout(() => {
      this.stopIndividual();
    }, this.totalDuration * 1000);

    this.audioContext.resume();
  }

  stopIndividual(){
    if(this.status != "playingIndividual"){
      return;
    }

    this.individualSound.buffers.forEach((buffer, j) => {
      buffer.stop();
    });
    //Recreate the AudioBufferSource so that we are ready to start again.
    this.individualSound.reload();

    clearTimeout(this.playingTimeout);

    this.individualSound = null

    this.status = "ready"

    //If we were previewing and item, we reload the list where
    if(this.cuedList != null){
      this.setList(this.cuedList);
    }
  }

  pause(){
    //Not implemented
    this.audioContext.suspend();
    this.pausedTime = this.audioContext.currentTime;

    clearTimeout(this.playingTimeout);
    clearInterval(this.progressInterval);

    this.status = "paused"

  }

  resume(){

    this.playingTimeout = setTimeout(() => {

      if(typeof this.onFinished == 'function'){
        this.onFinished();
      }

      this.stop();
    }, (this.totalDuration - (this.pausedTime - this.previousTime)) * 1000);

    this.progressInterval = setInterval(() => {
      let progress = (this.audioContext.currentTime - this.previousTime) / this.totalDuration;

      if(typeof this.onProgress == 'function'){
        this.onProgress(progress);
      }

    }, 50);

    this.audioContext.resume();

    this.status = "playing"
  }

  setVolume(vol){
    this.globalGain.gain.value = vol;
  }

  //Internal methods
  checkLoading(){
      //Treat assets separetly
      let assetsLoaded = true;
      this.assets.forEach((asset, i) =>{
        if(!asset.loaded()){
          assetsLoaded = false;
        }
      })

      //Goes through the list of sounds and call the loading callback with the sounds that are not ready to play
      let listLoaded = true;
      let loadedSoundIds = [];
      let notLoadedSoundIds = [];
      this.list.forEach((sound, i) =>{
        if(!sound.loaded()){
          listLoaded = false;
          notLoadedSoundIds.push(sound.context.index)
        }else{
          loadedSoundIds.push(sound.context.index)
        }
      })

      //When they are all loaded, we are ready to play
      if(assetsLoaded && listLoaded){
        this.status = "ready";
        if(typeof this.onReady == 'function'){
          this.onReady();
        }

      }
      //If not, we give feedback on what is ready and what isn't
      else{
        this.status = "loading";
        if(typeof this.onLoading == 'function'){
          this.onLoading(loadedSoundIds, notLoadedSoundIds);
        }
      }

  }

  soundLoaded(snd){
    if(this.status == "waitingIndividual" && snd.context.index == this.individualSound.context.index){
      //Playback right away
      this.playIndividual();

    }else{
      this.checkLoading();
    }
  }

  soundUnloaded(){
      //Not implemented
  }
}
